/**
 * ThreeDModel icon — stylized cube with two arrows around it, representing rotation.
 * Represents the 3D model view mode. Used in Mobile navigation and VisualizationView CTA.
 * Uses `currentColor` for stroke.
 */
export function ThreeDModel({
	className,
	arrowsClassName,
	width = '1em',
	height = '1em',
	...rest
}) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 24 24"
			stroke="none"
			fill="currentColor"
			strokeWidth="0"
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden="true"
			className={className}
			{...rest}
		>
			<g transform="matrix(.26313 0 0 .26313 -11.026 -259.57)">
				<g className={arrowsClassName}>
					<path d="m114.63 1061.1a37.795 37.795 0 0 1-61.712-29.266 37.795 37.795 0 0 1 2.3581-13.141l1.6111 4.8439 7.1727-2.3857-5.2953-15.92-16.858 0.192 0.08612 7.5586 7.5098-0.086a45.354 45.354 0 0 0-4.1433 18.938 45.354 45.354 0 0 0 74.641 34.631z" />
					<path d="m61.422 997.18a45.354 45.354 0 0 1 74.641 34.631 45.354 45.354 0 0 1-4.1456 18.943l7.512-0.091 0.0861 7.5586-16.858 0.1921-5.2953-15.92 7.1727-2.3857 1.6111 4.8438a37.795 37.795 0 0 0 2.3581-13.141 37.795 37.795 0 0 0-61.714-29.264z" />
				</g>
				<path
					id="cube-top"
					d="m72.043 1015.5 18.665 8.7114 18.665-8.7114-18.665-8.7095z"
				/>
				<path
					id="cube-right"
					d="m113.84 1021.7-19.355 9.0332v24.362l19.355-9.0331z"
				/>
				<path
					id="cube-left"
					d="m86.929 1055.1v-24.362l-19.355-9.0332v24.362z"
				/>
			</g>
		</svg>
	);
}
